import styles from "./TradeInUnavailable.module.scss";
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/v2/Message";
import { useTradeInContext } from "../../../TradeInContext";
import { MicrositeCTAUI } from "../../MicrositeCTA/MicrositeCTAUI";

const TradeInUnavailable = () => {
  const { errorMessage } = useTradeInContext();

  if (!errorMessage) return null;

  return (
    <>
      <Message
        title={errorMessage.title}
        body={errorMessage.body}
        type={errorMessage.type}
        className={styles.unavailable__error}
      />

      <div className={styles.unavailable__innerBlock}>
        <h2>Alternatively you could try</h2>
        <MicrositeCTAUI hasMultipleTradeInRoutes />
      </div>
    </>
  );
};

export default TradeInUnavailable;
